import { keys } from "../../../../constant/keyConfig";
import { getCookie } from "../../../../utils/cookies";
import { getItem } from "../../../../utils/localStorage";
import BrowserAccess from "../BrowserAccess";
import UpdateTeamsContext from "../UpdateTeamsContext";

function BrowserStorage() {
  const tokenId = getCookie(keys.SAAS_COMMON_BASE_TOKEN_ID);

  const contextInfo = getItem(keys.TEAMS_CONTEXT_KEY);

  if (tokenId && contextInfo) {
    return <UpdateTeamsContext contextInfo={contextInfo} />;
  }

  return <BrowserAccess />;
}

export default BrowserStorage;
